import { useEffect } from 'react';
import { AUTH_SCOPES } from '../constants';
import { msalInstance } from '../msal-instance';
import { useAuthStore } from '../auth.store';

export const useTokenValidation = () => {
  const { setAccount, account } = useAuthStore();

  useEffect(() => {
    (async () => {
      const activeAcc = msalInstance.getActiveAccount();
      if (!activeAcc) return;

      try {
        await msalInstance.acquireTokenSilent({
          scopes: AUTH_SCOPES,
          account: activeAcc,
        });
      } catch (error) {
        setAccount(null);
        await msalInstance.clearCache();
      }
    })();
  }, [setAccount, account]);
};
